import { createFileRoute } from "@tanstack/react-router"
import { CalendarPage, CalendarPageView } from "./-components/CalendarPage"

interface Search {
  view?: CalendarPageView
  startDate?: string
}

export const Route = createFileRoute("/app/my/calendar/")({
  component: CalendarPage,
  validateSearch: (search: Search) => search,
  beforeLoad: (ctx) => ({
    getTitle: () => ctx.context.t("Calendar"),
  }),
})
